var _g, _g2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgBackwardNavigationDisabled = function SvgBackwardNavigationDisabled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 53 45"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#backward-navigation-disabled_svg__a)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 26.5,
    cy: 17,
    fill: "#CCC",
    rx: 16.5,
    ry: 17
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#backward-navigation-disabled_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#4168AB",
    d: "M21.333 16.244c0-.238.09-.47.256-.654l5.555-6.133c.189-.209.46-.34.754-.365.294-.025.586.059.813.232.227.174.37.423.397.693a.97.97 0 0 1-.253.748l-4.977 5.48 4.8 5.479a.998.998 0 0 1 .202.354.944.944 0 0 1-.09.78c-.07.118-.165.223-.28.307a1.138 1.138 0 0 1-.393.208 1.202 1.202 0 0 1-.885-.078 1.09 1.09 0 0 1-.343-.273l-5.367-6.133a.962.962 0 0 1-.189-.645"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "backward-navigation-disabled_svg__b"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M36 5v23H16V5z"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "backward-navigation-disabled_svg__a",
    width: 53,
    height: 54,
    x: 0,
    y: 0,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 10
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1015_16425"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_1015_16425",
    result: "shape"
  })))));
};
export default SvgBackwardNavigationDisabled;